import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 22h12l-6-6-6 6zM23 3H1v16h6v-2H3V5h18v12h-4v2h6V3z"
}), 'AirplaySharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AirplaySharp.js
// module id = 1985
// module chunks = 2